import { render, staticRenderFns } from "./ReviewsFilterModal.vue?vue&type=template&id=d2165a1c"
import script from "./ReviewsFilterModal.vue?vue&type=script&lang=js"
export * from "./ReviewsFilterModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewsFilterModal.vue?vue&type=style&index=0&id=d2165a1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports